<template>
  <div>
    <v-row>
      <v-col>
        <h1 class="text-center">
          {{ $t('Selecciona día y hora') }}
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-date-picker
            color="primary"
            event-color="primary"
            no-title
            v-model="fecha"
            :min="today"
            full-width
            first-day-of-week="1"
            :locale="locale()"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-list v-if="!is_loading && (!horas || !horas.length)">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{$t('No hay horas disponibles para este día')}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <v-row class="contHoras">
      <v-col>
        <v-list v-if="horas && horas.length">
          <v-list-item v-for="(hora, index) in horas" :key="index" @click="set_hora(hora)">
            <v-list-item-content>
              <v-list-item-title v-text="hora.hora"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-icon>mdi-arrow-right</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import show_toolbar_mixin from "@/mixins/show_toolbar_mixin";
import {VueEasyJwt} from 'vue-easy-jwt'
import {locale} from "@/plugins/vue-i18n";

export default {
  name: 'Calendar',
  mixins: [show_toolbar_mixin],

  data() {
    return {
      jwt: new VueEasyJwt(),
      today: this.$moment().format("YYYY-MM-DD"),
      fecha: this.$moment().format("YYYY-MM-DD"),
      horas: []
    }
  },

  methods: {
    locale() {
      return locale
    },

    async get_horas() {
      this.horas = await this.$store.dispatch('reserva/get_horas', {
        fecha: this.fecha,
        centro: this.$store.state.reserva.centro,
        servicios: this.$store.state.reserva.servicio,
        include_genitales_masculinos: this.$store.state.reserva.include_genitales_masculinos
      })
    },

    set_hora (hora) {

      const { utm_source, utm_medium, utm_campaign } = this.get_utm_params()

      this.$store.commit('reserva/set_hora', hora.hora)
      this.$store.commit('reserva/set_empleado', hora.empleado)

      if (utm_source && utm_medium && utm_campaign) {
        this.$router.push({ name: 'confirmar_reserva', query: { utm_source, utm_medium, utm_campaign } })
      } else {
        this.$router.push({ name: 'confirmar_reserva' })
      }

    },

    get_utm_params () {
      const utm_source = this.$route.query.utm_source
      const utm_medium = this.$route.query.utm_medium
      const utm_campaign = this.$route.query.utm_campaign
      return { utm_source, utm_medium, utm_campaign }
    }
  },

  async mounted() {
    this.$store.commit('reserva/set_fecha', this.fecha)
    await this.get_horas()
  },

  computed: {
    centro() {
      return this.$store.state.centro.centro
    },
    is_loading() {
      return this.$store.state.loading
    },
    reserva() {
      return this.$store.state.reserva
    },
    user() {
      return this.$store.state.auth.user
    },
    total() {
      return (this.reserva.precioReserva - (this.descuento_online * this.reserva.precioReserva / 100)).toFixed(2)
    }
  },

  watch: {
    fecha(val) {
      this.horas = [];
      this.$store.commit('reserva/set_fecha', val)
      this.get_horas()
    }
  }
}
</script>

<style lang="less" scoped>
.contHoras {
  height: calc(100vh - 400px);
  overflow-y: auto;
}
</style>
